import { BaseKit, Bold, BulletList, Color, createVuetifyProTipTap, FontSize, Heading, History, HorizontalRule, Indent, Italic, Link, OrderedList, Table, TextAlign, VuetifyTiptap, VuetifyViewer } from 'vuetify-pro-tiptap';
import 'vuetify-pro-tiptap/style.css';
export const vuetifyProTipTap = createVuetifyProTipTap({
    lang: 'de',
    components: {
        VuetifyTiptap,
        VuetifyViewer
    },
    extensions: [
        BaseKit.configure({
            placeholder: {
                placeholder: 'Enter some text...'
            }
        }),
        TextAlign.configure({
            defaultAlignment: 'left',
        }),
        Bold,
        Italic,
        Heading,
        FontSize,
        Color,
        BulletList,
        OrderedList,
        Indent.configure({ divider: true }),
        Link,
        Table.configure({ divider: true }),
        HorizontalRule,
        History.configure({ divider: true }),
    ]
});
